import { render, staticRenderFns } from "./BlogPostsTitle.vue?vue&type=template&id=78572356&"
import script from "./BlogPostsTitle.vue?vue&type=script&lang=js&"
export * from "./BlogPostsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports